import React from "react";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.4 }
  }
};

const infoVariants = {
  hidden: { opacity: 0, x: -40 },
  visible: { 
    opacity: 1, 
    x: 0, 
    transition: { duration: 1, ease: [0.22, 1, 0.36, 1] } 
  }
};

const mapVariants = {
  hidden: { clipPath: "inset(0 0 100% 0)", opacity: 0 },
  visible: { 
    clipPath: "inset(0 0 0% 0)", 
    opacity: 1, 
    transition: { duration: 1.2, ease: [0.76, 0, 0.24, 1], delay: 0.6 } 
  }
};

export default function Contact() {
  return (
    <motion.section 
      className="contact-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {/* Cinematic Background Element */}
      <div className="contact-bg-text">GET IN TOUCH</div>

      <div className="contact-container">
        
        {/* LEFT: CONTACT INFO */}
        <motion.div className="contact-info" variants={infoVariants}>
          <motion.h2 className="section-title">
            Contact <span className="gold-text">Us</span>
          </motion.h2>

          <div className="address-block">
            <p className="company-name">Sippy Films Pvt. Ltd.</p>
            <p className="address-details">
              3G, Naaz Cinema Building,<br />
              Lamington Road,<br />
              Mumbai 400004,<br />
              Maharashtra, India
            </p>
          </div>

          <div className="contact-details">
            <div className="detail-item">
              <span>TEL</span>
              <p>+91 22 23870071</p>
            </div>
            <div className="detail-item">
              <span>FAX</span>
              <p>+91 22 23870073</p>
            </div>
            <div className="detail-item">
              <span>EMAIL</span>
              <p><a href="mailto:info@sippyfilms.com">info@sippyfilms.com</a></p>
            </div>
          </div>
        </motion.div>

        {/* RIGHT: MAP WITH REVEAL */}
        <motion.div className="contact-map-wrapper" variants={mapVariants}>
          <div className="map-shutter">
             <iframe
              title="Sippy Films Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.7465922830846!2d72.818456!3d18.95368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7ce171746927d%3A0x8f2d5754582f3c7e!2sNaaz%20Cinema!5e0!3m2!1sen!2sin!4v1715432000000"
              allowFullScreen
              loading="lazy"
            />
          </div>
          <div className="map-border" />
        </motion.div>

      </div>

      {/* FOOTER */}
      {/*<motion.footer 
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.5 }}
        transition={{ delay: 1.5 }}
        className="contact-footer"
      >
       © {new Date().getFullYear()} Sippy Films Pvt. Ltd. | Produced with Excellence
      </motion.footer>*/}

      <style>{`
        /* @font-face lives in src/styles/fonts.css — a url() inside an inline
           <style> resolves against the page URL, not this file, so it 404s. */
        .contact-page {
          background-color: #000;
          color: #fff;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          padding: 80px 5%;
          overflow: hidden;
        }

        .contact-bg-text {
          position: absolute;
          top: 10%;
          right: -5%;
          font-size: 12vw;
          font-weight: 900;
          color: rgba(255, 255, 255, 0.03);
          letter-spacing: -5px;
          pointer-events: none;
          white-space: nowrap;
        }

        .contact-container {
          display: grid;
          grid-template-columns: 1fr 1.2fr;
          gap: 100px;
          width: 100%;
          max-width: 1400px;
          z-index: 2;
        }

        .section-title {
          font-size: 4rem;
          text-transform: uppercase;
          font-family: 'SippyBold', sans-serif;
          margin-bottom: 40px;
          letter-spacing: -2px;
        }

        .gold-text { color: #0093c0; }

        .company-name {
          font-size: 1.5rem;
          font-weight: 700;
          font-family: 'SippyBold', sans-serif;
          margin-bottom: 10px;
          color:  #0093c0;  
        }

        .address-details {
          font-size: 1.1rem;
          line-height: 1.53;
            font-family: 'Sippy', sans-serif;
          color: rgba(255,255,255,0.7);
          margin-bottom: 40px;
        }

        .contact-details {
          display: flex;
            font-family: 'Sippy', sans-serif;
          flex-direction: column;
          gap: 20px;
        }

        .detail-item span {
          display: block;
          font-size: 0.8  rem;
          font-weight: 800;
          color: rgba(255,255,255,0.4);
          letter-spacing: 2px;
            font-family: 'Sippy', sans-serif;
          margin-bottom: 5px;
        }

        .detail-item p, .detail-item a {
          font-size: 1.2rem;
          color: #fff;
          text-decoration: none;
            font-family: 'SippyBold', sans-serif;
          transition: color 0.3s;
        }

        .detail-item a:hover { color:  #0093c0; }

        .contact-map-wrapper {
          position: relative;
          height: 500px;
          width: 100%;
        }

        .map-shutter {
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: 4px;
          filter: grayscale(1) invert(1) contrast(1.2); /* Cinematic Map Theme */
          transition: filter 0.5s ease;
        }

        .map-shutter:hover {
          filter: grayscale(0) invert(0) contrast(1);
        }

        /* Scoped: a bare iframe rule here restyled every iframe on the site
           for as long as this page stayed mounted. */
        .contact-page iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        .map-border {
          position: absolute;
          inset: -15px;
          border: 1px solid rgba(197, 160, 89, 0.2);
          z-index: -1;
        }

        .contact-footer {
          position: absolute;
          bottom: 40px;
          font-size: 0.7rem;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: #f3f3f3b3;
        }

        @media (max-width: 1024px) {
          .contact-container { grid-template-columns: 1fr; gap: 60px; }
          .contact-map-wrapper { height: 350px; }
          .section-title { font-size: 3rem; }
        }
      `}</style>
    </motion.section>
  );
}